import { render, staticRenderFns } from "./AdditionalSetupContactAdmin.vue?vue&type=template&id=247a3ac4&scoped=true&"
import script from "./AdditionalSetupContactAdmin.vue?vue&type=script&lang=js&"
export * from "./AdditionalSetupContactAdmin.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalSetupContactAdmin.vue?vue&type=style&index=0&id=247a3ac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247a3ac4",
  null
  
)

export default component.exports